<template>
  <div class="card base-page-card">
    <div class="card-content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "BasePageCard",
};
</script>
